<div>
  <app-country-vs-wf-filters *ngIf="years"
    [years]="years"
    [categories]="categories"
    [countryCategory]="countryCategory"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)">
  </app-country-vs-wf-filters>
  <mat-divider></mat-divider>
  <app-country-vs-wf-bar-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [countryCategory]="countryCategory"
    [countryCodes]="countryCodes"
    [country]="country"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-country-vs-wf-bar-chart>
</div>
